




















import Vue, { PropType } from 'vue'
import { gmapApi } from 'vue2-google-maps'
import { Marker } from '@/components/Map/types'

export default Vue.extend({
  name: 'InfoWindow',
  props: {
    marker: Object as PropType<Marker>
  },
  computed: {
    google: gmapApi,
    open (): boolean { return Object.keys(this.marker).length > 0 },
    infoWindowOptions (): google.maps.InfoWindowOptions {
      const offset = !this.google
        ? {}
        : { pixelOffset: new this.google.maps.Size(0, -30) }

      return {
        maxWidth: 400,
        ...offset
      }
    },
    time (): Date {
      const time = this.marker.positioned_at || this.marker.received_at || ''
      return time === ''
        ? '--:--'
        : this.$moment.utc(time).fromNow()
    }
  }
})
